export const _regularExpressions = {
    letterPattern: new RegExp('^[a-zA-Z\'\\s\\-]+$'),
    phonePattern: new RegExp("^(((\\+44)|(0044)|(0))(\\d{4})(\\s?)(\\d{3})(\\s?)(\\d{3}))$|^(((\\+44)|(0044)|(0))(\\s?)(\\d{3})(\\s?)(\\d{3})(\\s?)(\\d{4}))$"),
    phonePatternError: 'Enter a telephone number, like 01632 960 001, 07700 900 982 or +44 808 157 0192',
    emailPattern: new RegExp('^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$'),
    emailPatternError: 'Enter an email address in the correct format, like name@example.com',
    numbersPattern: new RegExp('[0-9]*'),
    nhsNumberPattern: new RegExp('^(?:[0-9]{10}|)$'),
    postcodePattern: new RegExp('^([A-Z]{1,2}\\d{1,2}[A-Z]?)\\s*(\\d[A-Z]{2})$'),
    postcodePatternError: 'Enter a valid UK postcode (example LS10 1AD)',
    spacePattern: new RegExp("\\s", "g") 
}